export default __webpack_public_path__ + "static/Connect-5535c6b4479e776cf6646debae99faa3.png";